import apiClient from './client';
import type { DashboardStats } from '../types';

// -------------------------------------------------------------------------
// API functions
// -------------------------------------------------------------------------

/** Parse a JSON-encoded string array, or pass through if already an array. */
function parseSkills(value: unknown): string[] {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.startsWith('[')) {
    try { return JSON.parse(value); } catch { /* fall through */ }
  }
  return [];
}

/**
 * Fetch aggregated dashboard statistics from the backend.
 * Keys are already converted to snake_case by the global response interceptor.
 */
export async function fetchDashboardStats(): Promise<DashboardStats> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data } = await apiClient.get<any>('/dashboard/stats');
  return {
    ...data,
    tenders_won: data.tenders_won ?? 0,
    tenders_lost: data.tenders_lost ?? 0,
    pending_matches: data.pending_matches ?? 0,
    recent_tenders: (data.recent_tenders ?? []).map((t: Record<string, unknown>) => ({
      ...t,
      required_skills: parseSkills(t.required_skills),
      nice_to_have_skills: parseSkills(t.nice_to_have_skills),
    })),
    recent_matches: data.recent_matches ?? [],
  };
}
